module.exports = __webpack_public_path__ + "static/media/apartment13.0bcaaa95.jpg";